export const getImageUrl = function(cid, item_id, size, seq) {
    if (!item_id) {
        return `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/` + cid + '_64.png'
    }

    let getSeq = seq && seq !== '0' && seq !== 0 ? '.' + seq : ''
    let getSize = size ? size : '140'

    getSize = getSize + getSeq

    const dir = Math.ceil(parseInt(item_id, 10) / 1000) * 1000
    return `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_` + dir + '/img_' + item_id + '/' + getSize + '.jpg'
}

export const getImageError = function(e, err) {
    if (e.target.src.indexOf(err) === -1 || err === "") {
        // e.target.src = err
        e.target.src = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/no_item_img.jpg`
    }
}

export const getNoImageUrl = function(cid, size) {
    let callCateID = ''
    if (cid.toString().substr(0, 1) === '1') {
        callCateID = cid.toString()
    } else if (cid.toString().substr(0, 1) === '2') {
        callCateID = '2010000000'
    }

    let getSize = size ? size : '140'

    let noImageUrl = ''
    if (callCateID) {
        noImageUrl = `${process.env.REACT_APP_CDN_IMG}/img_shopping/img_goods/img_no/` + callCateID + '_' + getSize + '.png'
    }

    return noImageUrl
}

export const getImage = function(cid, item_id, size, seq) {
    let imgSize = size
    let noImgSize = size

    if (size.toString().indexOf(',') >= 0) {
        let tmp = size.split(',')
        imgSize = tmp[0]
        noImgSize = tmp[1]
    }

    let imgUrl = getImageUrl(cid, item_id, imgSize, seq)
    let noImgUrl = getNoImageUrl(cid, noImgSize)

    return { imgUrl: imgUrl, noImgUrl: noImgUrl }
}



// WEBPACK FOOTER //
// ./src/estimate_list/libs/item.js